// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/detal/" + {"66":"date-range-picker","176":"charts","180":"product-zoom","186":"filter-search","525":"choices"}[chunkId] + ".js";
};